// libs
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// types
import { Reducers } from 'store/types'

export interface PublicFormState {
  confirmed: boolean
  successText: string
}

const initialState: PublicFormState = {
  confirmed: false,
  successText: 'The form has been successfully submitted'
}

export const publicFormSlice = createSlice({
  name: Reducers.PUBLIC_FORMS,
  initialState,
  reducers: (create) => ({
    setPublicFormData: create.reducer((state, action: PayloadAction<Partial<PublicFormState>>) => ({
      ...state,
      ...action.payload
    }))
  }),
  selectors: {
    publicFormSelector: (state) => state
  }
})

export const { setPublicFormData } = publicFormSlice.actions

export const { publicFormSelector } = publicFormSlice.selectors
